// extracted by mini-css-extract-plugin
module.exports = {"infiniteBackground":"styles_infiniteBackground__20x8I","inflation":"styles_inflation__12Qwz"};